import React from 'react'
import PropTypes from 'prop-types'

class Router {
  constructor(initialRoute) {
    this.state = {
      currentRoute: initialRoute,
      history: [initialRoute],
    }
    this.subscribers = []
    this.subscribe = this.subscribe.bind(this)
    this.unsubscribe = this.unsubscribe.bind(this)
    this.getCurrentRoute = this.getCurrentRoute.bind(this)
    this.push = this.push.bind(this)
    this.pop = this.pop.bind(this)
    this.popToTop = this.popToTop.bind(this)
    this.canPop = this.canPop.bind(this)
  }

  subscribe(subscriber) {
    this.subscribers.push(subscriber)
  }

  unsubscribe(subscriber) {
    const index = this.subscribers.indexOf(subscriber)
    if (index !== -1) {
      this.subscribers.splice(index, 1)
    }
  }

  getCurrentRoute() {
    return this.state.currentRoute
  }

  setState(newState) {
    this.state = newState
    this.subscribers.forEach(sc => sc.onRouteChange && sc.onRouteChange(this.state.currentRoute))
  }

  push(route) {
    const { history } = this.state
    history.push(route)
    this.setState({
      currentRoute: route,
      history,
    })
  }

  pop() {
    const { history } = this.state
    if (!this.canPop()) {
      return
    }
    history.pop()
    const route = history[history.length - 1]
    this.setState({
      currentRoute: route,
      history,
    })
  }

  popToTop() {
    const { history } = this.state
    if (!this.canPop()) {
      return
    }
    const route = history[0]
    this.setState({
      currentRoute: route,
      history: [],
    })
  }

  canPop() {
    const { history } = this.state
    return history.length > 1
  }
}

class AccessNavigator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentRoute: props.router.getCurrentRoute(),
    }
    this.onRouteChange = this.onRouteChange.bind(this)
  }

  componentDidMount() {
    this.props.router.subscribe(this)
  }

  componentWillUnmount() {
    this.props.router.unsubscribe(this)
  }

  onRouteChange(currentRoute) {
    this.setState({ currentRoute })
  }

  render() {
    const { currentRoute } = this.state
    const { routes } = this.props
    if (!routes || routes.length === 0 || currentRoute === '') {
      return null
    }
    const route = routes.find(r => r.route === currentRoute)
    if (!route) {
      return null
    }
    const { component: Route } = route
    return <Route {...this.props.router} />
  }
}

AccessNavigator.propTypes = {
  router: PropTypes.instanceOf(Router),
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      route: PropTypes.string,
      component: PropTypes.func,
    })
  ),
}

export const createNewRouter = initialRoute => new Router(initialRoute)

export default AccessNavigator
